<template>
    <div class="select-wrap">
        <slot>
            <a-button type="primary" ghost @click="openModal">選擇場景</a-button>
        </slot>
        <a-modal v-model="modalVisible" @ok="confirm" @cancel="cancel" centered destroyOnClose dialogClass="common-modal"
            :closable="false" title="選擇需要應用到的場景" width="800px">
            <div class="all-check">
                <a-checkbox :indeterminate="indeterminate" :checked="allCheck" @change="checkAll">全選</a-checkbox>
            </div>
            <div class="scene-box">
                <a-row :gutter="[16, 16]">
                    <a-col span="4" v-for="(item, index) in sceneList" :key="index">
                        <div class="lists" :class="{ active: selectIds.includes(item.id) }" @click="checkEvent(item.id)">
                            <div class="img-box">
                                <div class="boxs">
                                    <img :src="item.thumb_path" />
                                </div>
                            </div>
                            <div class="titles">{{ item.name }}</div>
                        </div>
                    </a-col>
                </a-row>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    name: "SelectScene",
    props: {
        showTip: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modalVisible: false,
            sceneList: [],
            selectIds: []
        }
    },
    computed: {
        ...mapGetters(["vrbase", "userInfo"]),
        indeterminate() {
            let inde = true
            if (this.sceneList.length) {
                inde = this.selectIds.length && this.selectIds.length < this.sceneList.length ? true : false
            }
            return inde
        },
        allCheck() {
            let check = false
            if (this.sceneList.length) {
                check = this.selectIds.length == this.sceneList.length ? true : false
            }
            return check
        }
    },
    mounted() {
        const scenes = this.$deepClone(this.vrbase.scenes)
        this.sceneList = Object.values(scenes)
    },
    methods: {
        //保存方法
        confirm() {
            this.$emit('selected', this.selectIds)
            this.cancel()
        },
        //取消
        cancel() {
            this.modalVisible = false
            this.selectIds = []
        },
        //打開
        openModal() {
            if (this.showTip) {
                let self = this
                this.$confirm({
                    centered: true,
                    title: "該操作會清空所有内容",
                    content: "因當前場景沒有設置過內容，把空內容應用到其它場景會清空其它場景相應的內容，是否繼續？",
                    okText: '繼續清空',
                    cancelText: '我再想想',
                    onOk() {
                        self.modalVisible = true
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                });
            } else {
                this.modalVisible = true
            }
        },
        //全選
        checkAll() {
            if (!this.allCheck) {
                this.selectIds = []
                this.sceneList.forEach(obj => {
                    this.selectIds.push(obj.id)
                })
            } else {
                this.selectIds = []
            }
        },
        //選擇
        checkEvent(id) {
            const index = this.selectIds.findIndex(obj => obj == id)
            if (index != -1) {
                this.selectIds.splice(index, 1)
            } else {
                this.selectIds.push(id)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.all-check {
    background-color: #f1f1f1;
    padding: 10px 20px;
    margin-bottom: 20px;
}

.scene-box {
    height: 40vh;
    overflow: hidden;
    overflow-y: auto;
}

.lists {
    width: 100%;
    cursor: pointer;
    user-select: none;

    &.active {
        .img-box {
            .boxs {
                outline: #015c61 solid 3px;
                outline-offset: -3px;
            }
        }
    }

    .img-box {
        border-radius: 4px;
        overflow: hidden;
        height: 0;
        padding-top: 100%;
        position: relative;

        .boxs {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .tips {
                font-size: 14px;
                color: #aaa;
            }
        }
    }

    .titles {
        width: 100%;
        margin-top: 6px;
        font-size: 14px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
    }
}

.selectBtn{
    color: #d485ff;
    border-color: #d485ff;
}
</style>